import React, { createContext, useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { useAuthentication } from "./hooks";

import { FinalizeCampaign } from "../CheckoutDefault/components/FinalizeCampaign";
import Loading from "../Components/Loading/Loading";
import { notification } from "../services/helpers";
import { Header } from "./components";
import { checkoutAuthRequest } from "./requests/checkoutAuth.request";
import * as Styles from "./styles";

const ActionsContext = createContext({});

export function ActionsProvider({ ACTIONS_CONFIG }) {
  const homologLocationBase = "RECARGACORREIOS-HOMOLOGACAO";
  const currentLocationBase = window.location.pathname
    .split("/")[1]
    .toUpperCase();

  const {
    STEPS,
    BASE_PATH,
    HIDE_HEADER,
    HIDE_HEADER_BACK,
    STORAGE_KEY,
    AUTH_TYPE,
  } = ACTIONS_CONFIG;

  const { push, replace } = useHistory();
  const location = useLocation();

  const splittedHash = location.hash.split("?");
  const hash = splittedHash[0];
  const search =
    !location.search || location.search === ""
      ? !!splittedHash[1]
        ? `?${splittedHash[1]}`
        : ""
      : location.search;

  const [isLoading, setIsLoading] = useState(false);
  const [actionsState, setActionsState] = useState(
    sessionStorage.getItem("hasLoadedData") === "true"
      ? JSON.parse(localStorage.getItem(`${STORAGE_KEY}/state`) || "{}") || {}
      : {}
  );

  const { handleValidatePhone } = useAuthentication({ setIsLoading });

  const haveStep = STEPS.find((step) => hash.includes(step.path));

  useEffect(() => {
    async function handleAuthentication() {
      if (sessionStorage.getItem("hasLoadedData") === "true" || isLoading)
        return;

      try {
        setIsLoading(true);
        const token = new URLSearchParams(search).get("token");
        const response = await checkoutAuthRequest({
          token,
        });
        await handleValidatePhone({
          phone: response.data.msisdn,
          publicToken: token,
        });

        handleUpdateActionsState({
          msisdn: response.data.msisdn,
          enabledPaymentTypes: response.data.payment_type,
          plan: {
            name: response.data.plan_name,
            value: response.data.value,
            enable_program: response.data.program,
          },
        });
        sessionStorage.setItem("hasLoadedData", true);
      } catch (error) {
        await notification(
          "error",
          "Não foi possível carregar informações da campanha"
        );
        replace("/");
      } finally {
        setIsLoading(false);
      }
    }

    if (AUTH_TYPE === "token") {
      if (homologLocationBase === currentLocationBase) return;

      if (!haveStep) replace(`${BASE_PATH}#${STEPS[0].path}${search || ""}`);

      if (search?.includes("token=")) {
        handleAuthentication();
      }
    } else {
      handleUpdateActionsState({
        enabledPaymentTypes: ["PIX", "CARTAO"],
      });
    }
  }, [search, haveStep]);

  if (homologLocationBase === currentLocationBase && AUTH_TYPE === "token")
    return <FinalizeCampaign />;

  if (!haveStep) replace(`${BASE_PATH}#${STEPS[0].path}${search || ""}`);

  const currentStep = hash.replace("#", "") || STEPS[0].path;
  const currentStepIndex = STEPS.findIndex(({ path }) =>
    currentStep?.includes(path)
  );

  const stepManager = {
    previous: () => {
      if (currentStepIndex === 0) return;

      const { path } = STEPS[currentStepIndex - 1];

      return push(`${BASE_PATH}#${path}${search || ""}`);
    },
    next: () => {
      if (currentStepIndex === STEPS.length - 1) return;

      const { path } = STEPS[currentStepIndex + 1];

      return push(`${BASE_PATH}#${path}${search || ""}`);
    },
    set: (path) => {
      const { path: pathStep } = STEPS.find(({ path: pathStep }) =>
        path.includes(pathStep)
      );

      return push(`${BASE_PATH}#${pathStep}${search || ""}`);
    },
  };

  function handleUpdateActionsState(state) {
    setActionsState((prevState) => {
      const newState = { ...prevState, ...state };
      return newState;
    });
  }

  const rawStep = currentStep.replace("/", "");

  const hideHeader = !currentStep || HIDE_HEADER?.includes(rawStep);
  const hideBackButton = HIDE_HEADER_BACK?.includes(rawStep);

  const Step = STEPS.find(({ path }) => currentStep.includes(path)).component;

  return (
    <ActionsContext.Provider
      value={{
        stepManager,
        currentStep,
        isLoading,
        setIsLoading,
        actionsState,
        setActionsState: handleUpdateActionsState,
        config: ACTIONS_CONFIG,
      }}
    >
      <Styles.ActionsContainer>
        {!hideHeader && <Header hideBackButton={hideBackButton} />}
        {isLoading && <Loading loading={1} />}
        <Step />
      </Styles.ActionsContainer>
    </ActionsContext.Provider>
  );
}

export const useActions = () => useContext(ActionsContext);
